<script setup lang="ts">
import type { FullWidthContentStoryblok } from "#storyblok-components";

defineProps<{ blok: FullWidthContentStoryblok }>();
</script>

<template>
  <FullWidthContentBlock
    v-editable="blok"
    :asset="blok.backgroundImage?.filename"
    :mobile-asset="blok.mobileImage?.filename"
    :overlay-opacity="blok.overlayOpacity?.value"
    :button-text="blok.buttonText"
    :description="blok.description"
    :heading="blok.heading"
    :link-path="blok.link"
    :size="blok.size"
    :text-position="blok.textPosition"
    :is-fifty-fifty="blok.isFiftyFifty"
  />
</template>
